const MovementsServiceFactory = function MovementsServiceFactory($q, endPoints, NewTokenService, NewBackendService) {
  'ngInject';

  const service = {
      exportCsv: (filterOptions) => {
      //const idWallet = NewTokenService.getMerchantWalletID();
      // manca ancora lato BE la possibilità di filtrare i movimenti
      // per tipo Entrata-Uscita (INCOMING-OUTCOMING)
      /*const dataFilter = filterOptions.dataDa && filterOptions.dataA ?
            `${filterOptions.dataDa}/${filterOptions.dataA}` : 'null/null';*/
      const url = `${endPoints.userUrl}/documents/bank-account/wallet-transaction/xls`;
      $q((resolve, reject) => {
      NewBackendService.invokeWebApiGet(url, filterOptions, undefined, "blob").then(
        response => {
          var reader = new FileReader();
          var blob = new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
          reader.readAsDataURL(blob);
          reader.onloadend = function (e) {
            var a = document.createElement('a');
            document.body.appendChild(a);
            a.setAttribute('style', 'display: none');
            a.href = reader.result;
            a.download = "export.xls";
            a.click();
            a.remove();
          }
        
        resolve(response);
      }, error => {
        reject(error);
      })
      })
    }
    /*exportCsv: (idIstrument, filterOptions) => {
      const idWallet = NewTokenService.getMerchantWalletID();
      // manca ancora lato BE la possibilità di filtrare i movimenti
      // per tipo Entrata-Uscita (INCOMING-OUTCOMING)
      const dataFilter = filterOptions.dataDa && filterOptions.dataA ?
            `${filterOptions.dataDa}/${filterOptions.dataA}` : 'null/null';
      const url = `${endPoints.webApiUrl}static-assets/documents/getDocumentAsAttachment/getAllCsvMovements/${idIstrument}/false/2/tipiMovimento;2;3;4;10/${dataFilter}?x-authorization-eai-idwallet=${idWallet}`;
      $log.debug(url);
      window.open(url, '_blank');
    }*/
  };

  return service;
};

export default MovementsServiceFactory;



/** WEBPACK FOOTER **
 ** ./client/app/common/services/movements.factory.js
 **/